import * as React from 'react';
import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, IconButton, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import useStyles from 'src/app/maintenance/assets/styles';

export const ConfirmPopup = ({ open, closePopup, handleConfirm,title, info,handleDiscardConfirm,type}) => {
  const style=useStyles();
    return (
        <Dialog open={open}>
            <Box>
                <DialogTitle style={{boxShadow:" 0px 4px 40px 0px #00000014" ,padding:"20px 10px 20px 10px"}}>
                    <Box
                        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}
                    >
                        <span>{title|| "Confirm"}</span>
                        <IconButton
                            onClick={closePopup}
                            style={{ paddingRight: '0px' }}
                            size="small"
                        >
                            <Close />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent style={{ margin: '0px' }}>
                    <Grid item style={{ marginBottom: '15px', marginRight: '15px' }}>
                        <Typography style={{color:"#324054"}}>
                            {info}
                        </Typography>
                    </Grid>
                    <Grid container justifyContent='flex-end'>
                        <Grid item style={{ display: 'flex', justifyContent: 'flex-end'}}>
                            <Button variant='outlined' className={style.buttonBackLight} onClick={handleDiscardConfirm} >{type=="reinstall"?"No":"Cancel"}</Button>
                            <Button variant='contained' className={style.customButton}  onClick={() => handleConfirm()}>{type=="reinstall"? "Yes re-install":"Confirm"}</Button>
                        </Grid>
                    </Grid>


                </DialogContent>
            </Box>
        </Dialog>
    )
}
